import { render, staticRenderFns } from "./AccountSidebarAddCharge.vue?vue&type=template&id=5bc9b048&"
import script from "./AccountSidebarAddCharge.vue?vue&type=script&lang=js&"
export * from "./AccountSidebarAddCharge.vue?vue&type=script&lang=js&"
import style0 from "./AccountSidebarAddCharge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports